<template>
  <div id="inputs" style="height: 190px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {}
  },
  mounted() {
    const container = document.getElementById('inputs')
    const myChart = new Charts(container)
    myChart.setOption({
      title: {
        show: false,
      },
      legend: {
        data: [
          { name: '化肥', color: '#ec8d13' },
          { name: '农药', color: '#ce2d2f' },
        ],
        textStyle: { fill: '#cfcfcf' },
        top: 15,
        right: 0,
      },
      grid: { left: 0, right: 0, top: 0, bottom: 40 },
      xAxis: {
        data: [ '2019', '2020', '2021', '2022','2023'],
        axisLabel: {
          style: { fill: '#cfcfcf' },
          formatter: '{value}年',
        },
      },
      yAxis: {
        name: '', //用量（吨）
        data: 'value',
        position: 'right',
        axisLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
        splitLine: {
          style: { stroke: '#3f3f3f' },
        },
      },
      series: [
        {
          name: '化肥',
          data: [2540, 2130, 1860, 1630, 1480],
          type: 'line',
          stack: 'a',
          lineStyle: { stroke: '#ec8d13', lineWidth: 2 },
          label: {
            show: true,
            style: { fill: '#ec8d13' },
          },
        },
        {
          name: '农药',
          data: [2450, 2330, 2230, 1930, 1720],
          type: 'line',
          stack: 'a',
          lineStyle: { stroke: '#ce2d2f', lineWidth: 2 },
          label: {
            show: true,
            style: { fill: '#ce2d2f' },
          },
        },
      ],
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/administration-zone/inputs-zone.vue